import React from 'react';
import DashboardThemeEditor from './theme/DashboardThemeEditor.jsx';

function DashboardSidebar () {
    {/* Global theme editor. The theme options can be overridden at widget level. */}
    {/* Regarding widget theming:
        Options params, overrides are global widget options that work for all widgets (padding, font size etc...)
        Options chartType, baseTheme, palette are options reserved for AG Charts and are overridden by widget-level chart themes.
        AG Charts also supports params and overrides options but at the moment these need to be specified separately at widget-level for each chart widget. */}
    return (
      <DashboardThemeEditor />
    );
}

export default DashboardSidebar;
